import { EXTRAS_ID } from '@/constants';

const INSERT_ORDER = (state, order) => {
  const isExtra = (orderToValidate) => orderToValidate.mealInfo.dietInfo.id === EXTRAS_ID;
  if (isExtra(order)) {
    state.byUserWeek.push(order);
    return;
  }

  const orderIndex = state.byUserWeek.findIndex((stateOrder) => {
    const isSameEvent = stateOrder.menuEvent === order.menuEvent;
    return isSameEvent && !isExtra(stateOrder);
  });

  if (orderIndex > -1) {
    state.byUserWeek.splice(orderIndex, 1, order);
  } else {
    state.byUserWeek.push(order);
  }
};

const REMOVE_ORDER = (state, orderId) => {
  const orderIndex = state.byUserWeek.findIndex((stateOrder) => stateOrder.id === orderId);

  if (orderIndex > -1) {
    state.byUserWeek.splice(orderIndex, 1);
  }
};

const REMOVE_ORDERS_BY_MENU_EVENT = (state, order) => {
  const orderIndex = state.byUserWeek.findIndex(
    (stateOrder) => stateOrder.menuEvent === order.menuEvent
  );

  if (orderIndex > -1) {
    state.byUserWeek.splice(orderIndex, 1);
  }
};

const UPDATE_LOCAL_ORDERS_DATE = (state, date) => {
  state.byUserWeek = state.byUserWeek.filter((meal) => meal.menuInfo.date !== date);
};

const UPDATE_LOCAL_ORDERS_EVENT = (state, mealEvent) => {
  state.byUserWeek = state.byUserWeek.filter((meal) => meal.menuInfo.event !== mealEvent);
};

const SET_ORDERS_UPDATED = (state, wereOrdersUpdated) => {
  state.wereOrdersUpdated = wereOrdersUpdated;
};

const SET_USER_ORDERS_IDS_BEFORE_SYNC = (state, userOrdersIdsBeforeSync) => {
  state.userOrdersIdsBeforeSync = userOrdersIdsBeforeSync;
};

const SET_BULK_ORDERS_UPDATED = (state, bulkCreationOrdersCorrectly) => {
  state.bulkCreationOrdersCorrectly = bulkCreationOrdersCorrectly;
};

export default {
  INSERT_ORDER,
  REMOVE_ORDERS_BY_MENU_EVENT,
  REMOVE_ORDER,
  UPDATE_LOCAL_ORDERS_DATE,
  UPDATE_LOCAL_ORDERS_EVENT,
  SET_ORDERS_UPDATED,
  SET_USER_ORDERS_IDS_BEFORE_SYNC,
  SET_BULK_ORDERS_UPDATED,
};



// WEBPACK FOOTER //
// ./store/modules/orders/mutations.js